import api from './api';

const multipart = { headers: { 'Content-Type': 'multipart/form-data' } };

const whitelabelService = {
  getSettings: () => api.get('/whitelabel'),
  updateSettings: (data) => api.put('/whitelabel', data),

  // ─── Image uploads (one POST per field) ───────────────────────────────
  uploadLogo: (formData) => api.post('/whitelabel/logo', formData, multipart),
  uploadFavicon: (formData) => api.post('/whitelabel/favicon', formData, multipart),
  uploadOgImage: (formData) => api.post('/whitelabel/og-image', formData, multipart),
  uploadLoginBgImage: (formData) => api.post('/whitelabel/login-bg-image', formData, multipart),
  uploadEmailHeaderLogo: (formData) => api.post('/whitelabel/email-header-logo', formData, multipart),
  uploadInvoiceLogo: (formData) => api.post('/whitelabel/invoice-logo', formData, multipart),
  uploadPwaSplashBg: (formData) => api.post('/whitelabel/pwa-splash-bg', formData, multipart),

  // ─── Image lifecycle / global reset ───────────────────────────────────
  removeImage: (field) => api.delete(`/whitelabel/image/${encodeURIComponent(field)}`),
  resetToDefaults: () => api.post('/whitelabel/reset'),

  // ─── Action endpoints ─────────────────────────────────────────────────
  sendTestEmail: () => api.post('/whitelabel/test-email'),
  exportBrandPack: () => api.get('/whitelabel/export'),
  importBrandPack: (payload) => api.post('/whitelabel/import', payload),
  syncWhatsAppProfile: () => api.post('/whitelabel/whatsapp-profile-sync'),
  applyBrandToWidget: () => api.post('/whitelabel/apply-brand-to-widget'),
};

export default whitelabelService;
